export var IdActionButtonEntries;
(function (IdActionButtonEntries) {
    IdActionButtonEntries["WebExclusivePackage"] = "WebOnlyProfilePicture";
    IdActionButtonEntries["PI_AnniversaryGift"] = "PI_AnniversaryGift";
    IdActionButtonEntries["DailyLogin"] = "DailyLogin";
    IdActionButtonEntries["PIBirthdayGift"] = "PIBirthdayGift";
    IdActionButtonEntries["PISkyGift"] = "PISkygift";
    IdActionButtonEntries["PIWelcomeBack"] = "PIWelcomeBack";
    IdActionButtonEntries["GoldGrowthPackageAvailable"] = "GoldGrowthPackageAvailable";
    IdActionButtonEntries["PIPlayerLeagueReward"] = "PIPlayerLeagueReward";
    IdActionButtonEntries["PIPlayerLeagueRanking"] = "PIPlayerLeagueRanking";
    IdActionButtonEntries["PICoopLeagueReward"] = "PICoopLeagueReward";
    IdActionButtonEntries["PICoopLeagueRanking"] = "PICoopLeagueRanking";
    IdActionButtonEntries["PICollectLeagueReward"] = "PICollectLeagueReward";
    IdActionButtonEntries["PICollectLeagueRanking"] = "PICollectLeagueRanking";
    IdActionButtonEntries["PromoteLeagueLevel"] = "PromoteLeagueLevel";
    IdActionButtonEntries["DemoteLeagueLevel"] = "DemoteLeagueLevel";
    IdActionButtonEntries["ExpansionDiscount"] = "ExpansionDiscount";
    IdActionButtonEntries["ExternalBarnDiscount"] = "ExternalBarnDiscount";
    IdActionButtonEntries["Blog"] = "Blog";
    IdActionButtonEntries["PISystem"] = "PISystem";
    IdActionButtonEntries["PICafeGift"] = "PICafeGift";
    IdActionButtonEntries["PISony"] = "PISony";
    IdActionButtonEntries["CoopLevelUp"] = "CoopLevelUp";
    IdActionButtonEntries["Adventures"] = "Adventures";
    IdActionButtonEntries["PlayerLeagueStart"] = "PlayerLeagueStart";
    IdActionButtonEntries["CoopLeagueStart"] = "CoopLeagueStart";
    IdActionButtonEntries["ThemedEvents"] = "ThemedEvents";
    IdActionButtonEntries["SaveAccount"] = "SaveAccount";
    IdActionButtonEntries["WaterTower"] = "WaterTower";
    IdActionButtonEntries["Dog"] = "Dog";
    IdActionButtonEntries["ProjectFinished"] = "ProjectFinished";
    IdActionButtonEntries["Cafe"] = "Cafe";
    IdActionButtonEntries["PISatisfaction"] = "PISatisfaction";
    IdActionButtonEntries["PIFriendGift"] = "PIFriendGift";
    IdActionButtonEntries["PIPurchasePointsReward"] = "PIPurchasePointsReward";
    IdActionButtonEntries["CoopInvitation"] = "CoopInvitation";
    IdActionButtonEntries["Trader"] = "Trader";
    IdActionButtonEntries["QuestThree"] = "QuestThree";
    IdActionButtonEntries["PremiumHouseDiscount"] = "PremiumHouseDiscount";
    IdActionButtonEntries["PremiumAcreDiscount"] = "PremiumAcreDiscount";
    IdActionButtonEntries["PrimeTime"] = "PrimeTime";
    // web only
    IdActionButtonEntries["PromoteMobile"] = "PromoteMobile";
    IdActionButtonEntries["WebOnlyOffer"] = "WebOnlyOffer";
})(IdActionButtonEntries || (IdActionButtonEntries = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/hud-action-button/IdActionButtonEntries.ts
// module id = 215
// module chunks = 3